const toFixedNumber = (
  input: string | number | null | undefined,
  fixed: number = 2,
) => {
  if (!input) return 0;
  return Number(Number(input).toFixed(fixed));
};

export default toFixedNumber;
